export const calcCountInLength = (apiClient) => {
    return {
        build(params) {
            return apiClient.request('/standard/calcCountInLength', params);
        },
    };
};
